module.exports = __webpack_public_path__ + "assets/img/txt-title.3b8b566e.svg";